
import Vue from 'vue'
import defaultPic from '@/assets/images/user.png'

Vue.directive('loadImage', {
    inserted: function (el, binding, vnode, oldVnode) {
        const src = binding.value
        const defaultImage = defaultPic
        if (!src) {
            el.src = defaultImage
            return
        }
        const ImgObj = new Image()
        ImgObj.src = src //图片路径
        ImgObj.onload = () => {
            if (ImgObj.fileSize > 0 || (ImgObj.width > 0 && ImgObj.height > 0)) {
                el.src = src
            } else {
                el.src = defaultImage
            }
        }
        ImgObj.onerror = () => {
            el.src = defaultImage
        }
    },
    update: function (el, binding, vnode, oldVnode) {
        const src = binding.value
        const defaultImage = defaultPic
        if (!src) {
            el.src = defaultImage
            return
        }
        const ImgObj = new Image()
        ImgObj.src = src //图片路径
        ImgObj.onload = () => {
            if (ImgObj.fileSize > 0 || (ImgObj.width > 0 && ImgObj.height > 0)) {
                el.src = src
            } else {
                el.src = defaultImage
            }
        }
        ImgObj.onerror = () => {
            el.src = defaultImage
        }
    }
})



// WEBPACK FOOTER //
// ./src/directive/loadImage.js